import { Plus, Trash2 } from "lucide-react";
import { money, pc } from "../../lib/casePath";
import { Btn, Card, FieldGrid } from "../kit/Kit";
import { creditoFields } from "./fields";

export const StepCredito = ({ c, onChange, cat, result, ro }) => {
  const usos = c.cred.usos || [];
  const setUsos = (u) => onChange("cred.usos", u);
  const upd = (i, k, v) => setUsos(usos.map((u, j) => (j === i ? { ...u, [k]: v } : u)));
  const sumUsos = usos.reduce((s, u) => s + (Number(u.m) || 0), 0);
  const sc = result?.sched;
  const inp = "w-full rounded-xl border border-[#E2DDD5] bg-[#FAF8F5] px-3 py-2 text-sm outline-none focus:border-[#E8643C] focus:bg-white";
  return (
    <>
      <Card title="Términos del crédito" subtitle="Tabla de amortización en vivo con el motor." testid="step-credito">
        <FieldGrid fields={creditoFields} data={c} onChange={onChange} />
        {result && (
          <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-5" data-testid="credito-summary">
            {[["Monto total", money(result.total)], ["Tasa aplicada", `${result.rate.toFixed(2)}%`], ["Pago francés", money(sc.rows[Math.min(sc.g, sc.rows.length - 1)]?.pago)],
              ["Aportación fondo", money(sc.aport)], ["TIR nominal / CAT", `${pc(result.tirNom)} / ${pc(result.cat)}`]].map(([l, v]) => (
              <div key={l} className="rounded-xl bg-[#FAF8F5] p-4"><p className="text-xs font-semibold uppercase tracking-widest text-[#8C867A]">{l}</p><p className="font-serif-display mt-1 text-lg font-bold">{v}</p></div>
            ))}
          </div>
        )}
      </Card>
      <Card title="Uso de recursos" subtitle={`Asignado ${money(sumUsos)} de ${money(c.cred.recursos)}`} testid="usos-card"
        right={!ro && <Btn kind="secondary" onClick={() => setUsos([...usos, { d: cat.destinos[0][0], l: cat.destinos[0][0], m: 0, mec: cat.destinos[0][1] }])} data-testid="add-uso-button"><Plus size={15} /> Agregar destino</Btn>}>
        <div className="space-y-3">
          {usos.map((u, i) => (
            <div key={i} className="grid gap-3 rounded-xl border border-[#E2DDD5] p-4 lg:grid-cols-12" data-testid={`uso-row-${i}`}>
              <select className={`${inp} lg:col-span-3`} value={u.d} data-testid={`uso-destino-${i}`} onChange={(e) => { const d = cat.destinos.find((x) => x[0] === e.target.value); setUsos(usos.map((x, j) => (j === i ? { ...x, d: d[0], l: d[0], mec: d[1] } : x))); }}>
                {cat.destinos.map(([d]) => <option key={d}>{d}</option>)}
              </select>
              <input className={`${inp} lg:col-span-4`} value={u.l} onChange={(e) => upd(i, "l", e.target.value)} placeholder="Descripción" data-testid={`uso-descripcion-${i}`} />
              <input className={`${inp} text-right lg:col-span-2`} value={u.m} type="number" onChange={(e) => upd(i, "m", Number(e.target.value))} data-testid={`uso-monto-${i}`} />
              <p className="text-xs text-[#8C867A] lg:col-span-2">{u.mec}</p>
              {!ro && <button onClick={() => setUsos(usos.filter((_, j) => j !== i))} className="justify-self-end rounded-lg p-2 text-[#8C867A] hover:text-rose-600 lg:col-span-1" data-testid={`uso-delete-${i}`}><Trash2 size={15} /></button>}
            </div>
          ))}
          {Math.abs(sumUsos - c.cred.recursos) > 1 && <p className="text-sm text-amber-700" data-testid="usos-warning">La suma de destinos no coincide con los recursos solicitados.</p>}
        </div>
      </Card>
      {sc && (
        <Card title="Tabla de amortización" subtitle={`${sc.rows.length} meses · fases ${sc.phases.map((p) => `${p.fase} ${p.from}–${p.to}`).join(" · ")}`} testid="amortizacion-live">
          <div className="max-h-[480px] overflow-auto rounded-xl border border-[#E2DDD5]">
            <table className="w-full text-sm tabular-nums">
              <thead className="sticky top-0 bg-[#111] text-xs text-white"><tr>{["Mes", "Fase", "Saldo inicial", "Intereses", "Capital", "Pago", "IVA int.", "Aport. fondo", "Saldo final"].map((h) => <th key={h} className="px-3 py-2.5 text-right font-semibold first:text-left">{h}</th>)}</tr></thead>
              <tbody>{sc.rows.map((r) => (
                <tr key={r.m} className="border-t border-[#F2F0EC] hover:bg-[#FDF0EB]/40" data-testid={`amort-row-${r.m}`}>
                  <td className="px-3 py-1.5">{r.m}</td><td className="px-3 py-1.5 text-right text-xs text-[#8C867A]">{r.fase}</td>
                  {[r.saldoIni, r.interes, r.capital, r.pago, r.ivaInt, r.fondo, r.saldoFin].map((v, k) => <td key={k} className="px-3 py-1.5 text-right">{money(v)}</td>)}
                </tr>))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </>
  );
};
